import { patientComplianceAnalyticTooltipHandler } from "./patientComplianceAnalyticTooltipHandler";

const usePatientComplianceAnalyticChart = (data, filter, schedule) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      tooltip: {
        enabled: false,
        external: patientComplianceAnalyticTooltipHandler,
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 5,
          boxHeight: 5,
          usePointStyle: true,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Count of Patient",
        },
      },
      y2: {
        beginAtZero: true,
        min: 0,
        max: 110,
        title: {
          display: true,
          text: "Met Expectation (%)",
        },
        position: "right",
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          callback: function (value) {
            if (value === 110) return "";
            return value;
          },
        },
      },
      x: {
        ticks: {
          callback(val, _index) {
            let label = this.getLabelForValue(val);
            return label;
          },
        },
      },
    },
  };

  const chartData = {
    labels: data?.labels,
    datasets: [
      {
        label: "Met Expectation",
        data:
          data?.metExpectation?.length > 0
            ? data?.metExpectation?.map((item) =>
                item ? item?.[schedule] : null
              )
            : [],
        borderColor: "#5489D8",
        backgroundColor: "#5489D8",
        type: "line",
        fill: false,
        tension: 0.4,
        yAxisID: "y2",
      },
      {
        label: "Actual",
        actual: data?.actual?.map((actual) => actual),
        data:
          data?.actual?.length > 0
            ? data?.actual?.map((item) => (item ? item?.[schedule] : null))
            : [],
        borderColor: "#FFBB37",
        backgroundColor: "#FFBB37",
        type: "line",
        fill: false,
        tension: 0.4,
        yAxisID: "y",
      },
      {
        label: "Expected",
        expected: data?.expected?.map((expected) => expected),
        data:
          data?.expected?.length > 0
            ? data?.expected?.map((item) => (item ? item?.[schedule] : null))
            : [],
        borderColor: "#94ba33",
        backgroundColor: "#94ba33",
        type: "bar",
        fill: false,
        yAxisID: "y",
      },
    ],
  };

  return { options, chartData };
};

export default usePatientComplianceAnalyticChart;
